<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- desktop -->
        <div class="hidden lg:block h-full">
          <div class="flex h-full w-full">
            <div
              class="flex flex-col gap-4 lg:w-[50%] 2xl:w-[25%] rounded-3xl overflow-y-auto"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto rounded-b-3xl lg:rounded-b-none"
              >
                <div
                  v-for="(student, index) in this.studentList"
                  :key="index"
                  class=""
                >
                  <div
                    v-if="student.uuid"
                    :uuid="student.uuid"
                    @click="setActiveStudent(student)"
                    :class="[
                      'cursor-pointer',
                      activeStudentUUID === student.uuid
                        ? 'bg-gray-200'
                        : 'bg-white',
                    ]"
                    class="py-2 px-3 2xl:px-10 text-base lg:text-sm mb-0 hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.profile_image">
                          <img
                            :src="student.profile_image"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.to_user.username || "NA" }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>

                    <div class="">
                      <div
                        v-if="student.unread_user != null"
                        :class="
                          student.unread_message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.unread_message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>

            <div
              v-if="defaultimg"
              class="bg-white h-full rounded-3xl border w-full text-center lg:w-[70%] 2xl:w-[75%] flex flex-col justify-center"
            >
              <!-- Custom SVG -->
              <div class="flex justify-center mb-6">
                <img
                  src="@/assets/chat/default_img.png"
                  class=""
                  alt=""
                  srcset=""
                />
              </div>
              <!-- Title -->
              <h2 class="text-xl font-semibold text-gray-800">
                One-to-One Chat
                <span class="text-sm text-gray-500 align-top"></span>
              </h2>
              <!-- Description -->
              <p class="text-gray-600 text-sm mt-2">
                Chat privately with any user in real-time.
                <br />
                Share images, documents, videos, and stay synced across all your
                devices.
              </p>
              <!-- Footer -->
              <p class="text-xs text-gray-400 mt-4">
                All messages are secured with end-to-end encryption.
              </p>
            </div>

            <div
              v-if="selectedStudent"
              class="flex h-full w-full rounded-3xl overflow-hidden bg-[#F0F5F9] relative"
              :style="{
                backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
              }"
              :class="
                isFullScreenContact ? 'w-full' : ' lg:w-[70%] 2xl:w-[75%]'
              "
            >
              <!-- main -->
              <div
                :class="[
                  'transition-all duration-300 relative h-full',
                  showContactInfo && !isFullScreenContact
                    ? 'w-full  md:w-[calc(100%-350px)]'
                    : 'w-full ',
                ]"
                :style="{
                  backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
                }"
              >
                <div
                  class="flex flex-col h-full bg-black/20 rounded-3xl relative"
                >
                  <div
                    class="absolute w-full left-0 right-0 cursor-pointer"
                    @click="showContactInfo = true"
                  >
                    <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                      <div class="flex justify-center items-center gap-2">
                        <div class="">
                          <div v-if="this.selectedStudent.profile_image">
                            <img
                              :src="this.selectedStudent.profile_image"
                              alt=""
                              srcset=""
                              class="rounded-full w-6 h-6 mx-auto"
                            />
                          </div>
                          <img
                            v-else
                            src="@/assets/newd/image.png"
                            alt=""
                            srcset=""
                            class="w-6 h-6 object-contain"
                          />
                        </div>
                        <p class="text-center text-primary font-semibold">
                          {{ this.selectedStudent.to_user.username || "NA" }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="h-full w-full px-3 pt-14 pb-16">
                    <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                      <div
                        v-if="data_loding"
                        class="flex justify-center items-center h-full"
                      >
                        <img
                          src="@/assets/loading.gif"
                          alt="loading"
                          class="w-10 h-10 object-contain"
                        />
                      </div>

                      <div
                        v-else-if="this.totalmessage.length > 0"
                        v-for="(message, index) in totalmessage"
                        :key="index"
                        class="my-4 flex flex-col gap-1"
                      >
                        <template v-if="shouldShowDateLabel(index)">
                          <div
                            class="text-center font-semibold text-gray-200 text-xs"
                          >
                            <button
                              class="bg-blue-300 text-white py-1 px-2 rounded-md"
                            >
                              {{ formatDateLabel(message.created_at) }}
                            </button>
                          </div>
                        </template>
                        <div
                          v-if="message?.owner_email"
                          class="flex"
                          :class="[
                            'my-4 flex gap-2 w-full',
                            message.owner_email === this.userInfo.user.email
                              ? 'justify-end'
                              : 'justify-start',
                          ]"
                        >
                          <div
                            class="relative max-w-[350px] text-sm font-mono"
                            :class="[
                              !message.text && message.file
                                ? 'bg-transparent  text-gray-900'
                                : message.owner_email ===
                                  this.userInfo.user.email
                                ? 'bg-[#E8F6FF] text-gray-900 rounded-2xl px-4 py-2 shadow-md break-words rounded-br-sm'
                                : 'bg-gray-200 text-gray-900 rounded-2xl px-4 py-2  shadow-md break-words rounded-bl-sm',
                            ]"
                          >
                            <!-- File Preview from URL -->

                            <div
                              v-if="message.file"
                              class="mt-2 relative group w-fit"
                            >
                              <div
                                class="relative inline-block w-fit mt-2 group"
                              >
                                <!-- 🖼️ Image Preview -->
                                <img
                                  v-if="
                                    /\.(jpe?g|png|gif|webp|bmp)$/i.test(
                                      message.file
                                    )
                                  "
                                  :src="message.file"
                                  class="rounded w-40 shadow cursor-pointer"
                                  alt="Image"
                                />

                                <!-- 📽️ Video Preview -->

                                <video
                                  v-else-if="
                                    /\.(mp4|webm|ogg)$/i.test(message.file)
                                  "
                                  :src="message.file"
                                  controls
                                  class="rounded w-60 shadow"
                                ></video>

                                <div
                                  v-else
                                  class="p-2 rounded w-60 mr-4 text-sm text-blue-700 underline"
                                >
                                  📄
                                  {{
                                    message.filename ||
                                    getFileName(message.file)
                                  }}
                                </div>

                                <button
                                  @click="toggleDropdown(index)"
                                  class="absolute top-1 right-1 p-1 rounded-full text-white bg-black/50 2xl:bg-transparent 2xl:text-[#4f3f3fc3] 2xl:hidden 2xl:group-hover:block"
                                  title="Options"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-4 h-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </button>

                                <div
                                  v-if="dropdownIndex === index"
                                  class="absolute top-8 right-1 bg-white border rounded shadow text-xs z-50"
                                >
                                  <button
                                    @click="downloadFile(message)"
                                    class="px-4 py-2 hover:bg-gray-100 w-full text-left"
                                  >
                                    ⬇️ Download
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div>
                              <span v-if="message.text">{{
                                message.text
                              }}</span>
                              <!-- <span v-else>Na</span> -->
                            </div>
                            <p
                              class="text-[10px] flex gap-2 justify-end text-black/40 font-bold mt-1 hidden"
                            >
                              {{ formatDateTime(message.created_at) }}
                            </p>
                            <div
                              class="text-[10px] flex items-center gap-2 justify-end text-black/40 font-bold mt-1"
                            >
                              {{ formatDateTime(message.created_at) }}

                              <!-- <div v-if="message.readed">
                                <img
                                  src="@/assets/chat/double-tick-17.png"
                                  class="w-4 h-4"
                                  alt=""
                                  srcset=""
                                />
                              </div>
                              <div v-else class="">
                                <img
                                  src="@/assets/chat/icons8-double-tick-24.png"
                                  class="w-4 h-4"
                                  alt=""
                                  srcset=""
                                />
                              </div> -->
                              <span
                                v-if="
                                  message.owner_id === this.userInfo.user.id
                                "
                              >
                                <div v-if="message.readed">
                                  <img
                                    src="@/assets/chat/double-tick-17.png"
                                    class="w-4 h-4"
                                    alt=""
                                    srcset=""
                                  />
                                </div>

                                <div v-else class="">
                                  <img
                                    src="@/assets/chat/icons8-double-tick-24.png"
                                    class="w-4 h-4"
                                    alt=""
                                    srcset=""
                                  />
                                </div>
                              </span>
                            </div>
                            <div
                              v-if="
                                message.owner_email ===
                                  this.userInfo.user.email &&
                                (message.text || !message.file)
                              "
                              class="absolute right-0 bottom-0 translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-l-[10px] border-l-[#E8F6FF]"
                            ></div>

                            <div
                              v-else-if="
                                message.owner_email !==
                                  this.userInfo.user.email &&
                                (message.text || !message.file)
                              "
                              class="absolute left-0 bottom-0 -translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-gray-200"
                            ></div>
                          </div>
                        </div>
                      </div>

                      <!-- Dummy loading preview when loading a file -->
                      <div
                        v-if="sendingFileUrl"
                        class="my-4 flex gap-2 w-full justify-end"
                      >
                        <div
                          class="flex flex-col items-center justify-center p-4 rounded-lg bg-black/40 shadow-xl w-[230px] h-[100px]"
                        >
                          <img
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                          <p class="mt-2 text-white font-medium text-xs">
                            Loading…
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="absolute bottom-2 w-full left-0 right-0">
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                    >
                      <!-- Plus Button -->

                      <div class="relative">
                        <div
                          v-if="showIcons"
                          @click.stop
                          class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                        >
                          <!-- Document Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('document')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                                />
                                <path d="M14 2v6h6" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Document
                            </span>
                          </div>

                          <!-- Image Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('image')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="3"
                                  width="18"
                                  height="18"
                                  rx="2"
                                />
                                <circle cx="8" cy="8" r="1.5" />
                                <path d="M21 15l-5-5L5 21" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Image
                            </span>
                          </div>

                          <!-- Video Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('video')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="5"
                                  width="15"
                                  height="14"
                                  rx="2"
                                />
                                <path d="M21 7l-5 4v2l5 4V7z" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Video
                            </span>
                          </div>

                          <input
                            ref="document"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            class="hidden"
                            @change="handleFile('document', $event)"
                          />
                          <input
                            ref="image"
                            type="file"
                            accept="image/*"
                            class="hidden"
                            @change="handleFile('image', $event)"
                          />
                          <input
                            ref="video"
                            type="file"
                            accept="video/*"
                            class="hidden"
                            @change="handleFile('video', $event)"
                          />
                        </div>

                        <!-- Plus Button -->
                        <button
                          @click.stop="toggleIcons"
                          class="w-8 h-8 text-white rounded-full flex items-center justify-center hover:bg-[#E8F6FF]"
                          title="Add"
                        >
                          <div v-if="!showIcons">
                            <img src="@/assets/chat/plus.svg" alt="" />
                          </div>
                          <div
                            v-else
                            class="text-[#34A9F1] bg-[#E8F6FF] rounded-full p-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>

                      <!-- Input + Preview -->
                      <div class="flex flex-col w-full gap-2">
                        <!-- File Preview -->
                        <div
                          v-if="fileData.name"
                          class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                        >
                          <div class="flex justify-between items-start">
                            <div>
                              <p class="text-xs font-semibold mb-1">Preview:</p>

                              <template v-if="fileData.type === 'image'">
                                <img
                                  :src="fileData.url"
                                  alt="Preview"
                                  class="w-40 rounded shadow"
                                />
                              </template>
                              <template v-else-if="fileData.type === 'video'">
                                <video
                                  :src="fileData.url"
                                  controls
                                  class="w-60 rounded shadow"
                                />
                              </template>
                              <template v-else>
                                <p class="text-xs text-gray-700">
                                  {{ fileData.name }}
                                </p>
                              </template>
                            </div>
                            <button
                              @click="clearPreview"
                              class="text-red-500 hover:text-red-700 text-sm"
                            >
                              ✕
                            </button>
                          </div>
                        </div>

                        <!-- Text Input -->
                        <input
                          v-model="messageVal"
                          @keyup.enter="sendmsg(selectedStudent)"
                          type="text"
                          class="w-full border-none outline-none text-sm bg-transparent text-gray-800"
                          placeholder="Type your text here..."
                        />
                      </div>
                      <button
                        @click="sendmsg(this.selectedStudent)"
                        class="w-[40px] h-[40px] rounded-full flex items-center justify-center"
                      >
                        <img src="@/assets/chat/right.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right Side Contact Panel -->
              <transition name="slide">
                <div
                  v-if="showContactInfo"
                  class="absolute top-0 right-0 h-full w-full bg-gray-800 text-white rounded-l-3xl z-40 shadow-lg overflow-y-auto"
                  :class="
                    isFullScreenContact ? 'w-full' : 'w-full 2xl:w-[350px]'
                  "
                >
                  <div
                    class="flex justify-between items-center p-4 border-b border-white/10"
                  >
                    <h2 class="text-lg font-semibold">Contact Info</h2>
                    <button
                      @click="showContactInfo = false"
                      class="text-white text-2xl"
                    >
                      &times;
                    </button>
                  </div>

                  <div class="p-4">
                    <div class="text-center mb-4">
                      <img
                        v-if="selectedStudent.profile_image"
                        :src="selectedStudent.profile_image"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Profile"
                      />
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Default"
                      />
                      <h3 class="mt-2 font-semibold text-lg">
                        {{ selectedStudent.to_user.username }}
                      </h3>
                      <p class="text-sm text-gray-400">
                        Hey there! I am using Messages.
                      </p>
                    </div>

                    <!-- Media/docs preview -->
                    <div class="hidden">
                      <h4 class="font-semibold text-sm text-gray-400 mb-2">
                        Media, Docs
                      </h4>
                      <div class="grid grid-cols-3 gap-2">
                        <div
                          v-for="n in 3"
                          :key="n"
                          class="w-full h-20 bg-white/10 rounded"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <!-- mobile -->
        <div class="block lg:hidden h-full">
          <div class="flex h-full">
            <div
              v-if="studentmessage"
              class="flex flex-col gap-4 w-full overflow-y-auto rounded-3xl"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto"
              >
                <div
                  v-for="(student, index) in this.studentList"
                  :key="index"
                  class=""
                >
                  <div
                    v-if="student.uuid"
                    @click="setActiveStudent(student)"
                    :class="[
                      'cursor-pointer',
                      activeStudentUUID === student.uuid
                        ? 'bg-gray-200'
                        : 'bg-white',
                    ]"
                    class="py-3 px-5 text-base lg:text-sm mb-0 hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.profile_image">
                          <img
                            :src="student.profile_image"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.to_user.username }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>
                    <div class="hidden">
                      <div
                        v-if="student.unread_user != null"
                        :class="
                          student.unread_message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.unread_message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>

            <div
              v-if="selectedStudent"
              class="flex h-full w-full rounded-3xl overflow-hidden bg-[#F0F5F9] relative"
            >
              <!-- main -->
              <div
                :class="[
                  'transition-all duration-300 relative h-full',
                  showContactInfo && !isFullScreenContact
                    ? 'w-full  md:w-[calc(100%-350px)]'
                    : 'w-full ',
                ]"
                :style="{
                  backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
                }"
              >
                <div
                  class="flex justify-end pr-4"
                  @click="
                    selectedStudent = false;
                    studentmessage = true;
                  "
                >
                  <p
                    class="text-blues rounded-lg text-sm font-semibold underline cursor-pointer"
                  >
                    Back
                  </p>
                </div>

                <div class="flex flex-col h-full rounded-3xl relative">
                  <div
                    class="absolute w-full left-0 right-0 cursor-pointer"
                    @click="showContactInfo = true"
                  >
                    <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                      <div class="flex justify-center items-center gap-2">
                        <div class="">
                          <div v-if="this.selectedStudent.profile_image">
                            <img
                              :src="this.selectedStudent.profile_image"
                              alt=""
                              srcset=""
                              class="rounded-full w-6 h-6 mx-auto"
                            />
                          </div>
                          <img
                            v-else
                            src="@/assets/newd/image.png"
                            alt=""
                            srcset=""
                            class="w-6 h-6 object-contain"
                          />
                        </div>
                        <p class="text-center text-primary font-semibold">
                          {{ this.selectedStudent.to_user.username }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="h-full w-full px-3 pt-14 pb-16">
                    <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                      <div
                        v-for="(message, index) in totalmessage"
                        :key="index"
                        class="my-4 flex flex-col gap-1"
                      >
                        <template v-if="shouldShowDateLabel(index)">
                          <div
                            class="text-center font-semibold text-gray-200 text-xs"
                          >
                            <button
                              class="bg-blue-300 text-white py-1 px-2 rounded-md"
                            >
                              {{ formatDateLabel(message.created_at) }}
                            </button>
                          </div>
                        </template>
                        <div
                          v-if="message?.owner_email"
                          class="flex"
                          :class="[
                            'my-4 flex gap-2 w-full',
                            message.owner_email === this.userInfo.user.email
                              ? 'justify-end'
                              : 'justify-start',
                          ]"
                        >
                          <div
                            class="relative max-w-[350px] text-sm font-mono"
                            :class="[
                              !message.text && message.file
                                ? 'bg-transparent  text-gray-900'
                                : message.owner_email ===
                                  this.userInfo.user.email
                                ? 'bg-[#E8F6FF] text-gray-900 rounded-2xl px-4 py-2 shadow-md break-words rounded-br-sm'
                                : 'bg-gray-200 text-gray-900 rounded-2xl px-4 py-2  shadow-md break-words rounded-bl-sm',
                            ]"
                          >
                            <!-- File Preview from URL -->

                            <div
                              v-if="message.file"
                              class="mt-2 relative group w-fit"
                            >
                              <div
                                class="relative inline-block w-fit mt-2 group"
                              >
                                <!-- 🖼️ Image Preview -->
                                <img
                                  v-if="
                                    /\.(jpe?g|png|gif|webp|bmp)$/i.test(
                                      message.file
                                    )
                                  "
                                  :src="message.file"
                                  class="rounded w-40 shadow cursor-pointer"
                                  alt="Image"
                                />

                                <!-- 📽️ Video Preview -->
                                <video
                                  v-else-if="
                                    /\.(mp4|webm|ogg)$/i.test(message.file)
                                  "
                                  :src="message.file"
                                  controls
                                  class="rounded w-60 shadow"
                                ></video>

                                <div
                                  v-else
                                  class="p-2 rounded w-60 mr-4 text-sm text-blue-700 underline"
                                >
                                  📄
                                  {{
                                    message.filename ||
                                    getFileName(message.file)
                                  }}
                                </div>

                                <button
                                  @click="toggleDropdown(index)"
                                  class="absolute top-1 right-1 p-1 rounded-full text-white bg-black/50 2xl:bg-transparent 2xl:text-[#4f3f3fc3] 2xl:hidden 2xl:group-hover:block"
                                  title="Options"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-4 h-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </button>

                                <div
                                  v-if="dropdownIndex === index"
                                  class="absolute top-8 right-1 bg-white border rounded shadow text-xs z-50"
                                >
                                  <button
                                    @click="downloadFile(message)"
                                    class="px-4 py-2 hover:bg-gray-100 w-full text-left"
                                  >
                                    ⬇️ Download
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div>
                              <span v-if="message.text">{{
                                message.text
                              }}</span>
                              <!-- <span v-else>Na</span> -->
                            </div>

                            <p
                              class="text-[10px] flex justify-end text-black/40 font-bold mt-1"
                            >
                              {{ formatDateTime(message.created_at) }}
                            </p>
                            <div
                              v-if="
                                message.owner_email ===
                                  this.userInfo.user.email &&
                                (message.text || !message.file)
                              "
                              class="absolute right-0 bottom-0 translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-l-[10px] border-l-[#E8F6FF]"
                            ></div>

                            <div
                              v-else-if="
                                message.owner_email !==
                                  this.userInfo.user.email &&
                                (message.text || !message.file)
                              "
                              class="absolute left-0 bottom-0 -translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-gray-200"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <!-- Dummy loading preview when loading a file -->
                      <div
                        v-if="sendingFileUrl"
                        class="my-4 flex gap-2 w-full justify-end"
                      >
                        <div
                          class="flex flex-col items-center justify-center p-4 rounded-lg bg-black/40 shadow-xl w-[230px] h-[100px]"
                        >
                          <img
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                          <p class="mt-2 text-white font-medium text-xs">
                            Loading…
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="absolute bottom-2 w-full left-0 right-0">
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                    >
                      <!-- Plus Button -->

                      <div class="relative">
                        <div
                          v-if="showIcons"
                          @click.stop
                          class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                        >
                          <!-- Document Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('document')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                                />
                                <path d="M14 2v6h6" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Document
                            </span>
                          </div>

                          <!-- Image Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('image')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="3"
                                  width="18"
                                  height="18"
                                  rx="2"
                                />
                                <circle cx="8" cy="8" r="1.5" />
                                <path d="M21 15l-5-5L5 21" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Image
                            </span>
                          </div>

                          <!-- Video Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('video')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="5"
                                  width="15"
                                  height="14"
                                  rx="2"
                                />
                                <path d="M21 7l-5 4v2l5 4V7z" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Video
                            </span>
                          </div>

                          <input
                            ref="document"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            class="hidden"
                            @change="handleFile('document', $event)"
                          />
                          <input
                            ref="image"
                            type="file"
                            accept="image/*"
                            class="hidden"
                            @change="handleFile('image', $event)"
                          />
                          <input
                            ref="video"
                            type="file"
                            accept="video/*"
                            class="hidden"
                            @change="handleFile('video', $event)"
                          />
                        </div>

                        <!-- Plus Button -->
                        <button
                          @click.stop="toggleIcons"
                          class="w-8 h-8 text-white rounded-full flex items-center justify-center hover:bg-[#E8F6FF]"
                          title="Add"
                        >
                          <div v-if="!showIcons">
                            <img src="@/assets/chat/plus.svg" alt="" />
                          </div>
                          <div
                            v-else
                            class="text-[#34A9F1] bg-[#E8F6FF] rounded-full p-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>

                      <!-- Input + Preview -->
                      <div class="flex flex-col w-full gap-2">
                        <!-- File Preview -->
                        <div
                          v-if="fileData.name"
                          class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                        >
                          <div class="flex justify-between items-start">
                            <div>
                              <p class="text-xs font-semibold mb-1">Preview:</p>

                              <template v-if="fileData.type === 'image'">
                                <img
                                  :src="fileData.url"
                                  alt="Preview"
                                  class="w-40 rounded shadow"
                                />
                              </template>
                              <template v-else-if="fileData.type === 'video'">
                                <video
                                  :src="fileData.url"
                                  controls
                                  class="w-60 rounded shadow"
                                />
                              </template>
                              <template v-else>
                                <p class="text-xs text-gray-700">
                                  {{ fileData.name }}
                                </p>
                              </template>
                            </div>
                            <button
                              @click="clearPreview"
                              class="text-red-500 hover:text-red-700 text-sm"
                            >
                              ✕
                            </button>
                          </div>
                        </div>

                        <!-- Text Input -->
                        <input
                          v-model="messageVal"
                          @keyup.enter="sendmsg(selectedStudent)"
                          type="text"
                          class="w-full border-none outline-none text-sm bg-transparent text-gray-800"
                          placeholder="Type your text here..."
                        />
                      </div>
                      <button
                        @click="sendmsg(this.selectedStudent)"
                        class="w-[40px] h-[40px] rounded-full flex items-center justify-center"
                      >
                        <img src="@/assets/chat/right.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right Side Contact Panel -->
              <transition name="slide">
                <div
                  v-if="showContactInfo"
                  class="absolute top-0 right-0 h-full w-full bg-gray-800 text-white rounded-l-3xl z-40 shadow-lg overflow-y-auto"
                  :class="
                    isFullScreenContact ? 'w-full' : 'w-full 2xl:w-[350px]'
                  "
                >
                  <div
                    class="flex justify-between items-center p-4 border-b border-white/10"
                  >
                    <h2 class="text-lg font-semibold">Contact Info</h2>
                    <button
                      @click="showContactInfo = false"
                      class="text-white text-2xl"
                    >
                      &times;
                    </button>
                  </div>

                  <div class="p-4">
                    <div class="text-center mb-4">
                      <img
                        v-if="selectedStudent.profile_image"
                        :src="selectedStudent.profile_image"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Profile"
                      />
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Default"
                      />
                      <h3 class="mt-2 font-semibold text-lg">
                        {{ selectedStudent.to_user.username }}
                      </h3>
                      <p class="text-sm text-gray-400">
                        Hey there! I am using Messages.
                      </p>
                    </div>

                    <!-- Media/docs preview -->
                    <div class="hidden">
                      <h4 class="font-semibold text-sm text-gray-400 mb-2">
                        Media, Docs
                      </h4>
                      <div class="grid grid-cols-3 gap-2">
                        <div
                          v-for="n in 3"
                          :key="n"
                          class="w-full h-20 bg-white/10 rounded"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: [],
      studentList: [],
      activeStudentUUID: null,
      selectedStudent: null,
      ChatpopUp: false,

      loading: true,

      activeGroup: null,
      studentmessage: true,
      showIcons: false,
      message_list: null,
      fileData: {
        type: "",
        name: "",
        url: "",
        raw: null,
      },
      dropdownIndex: null,
      showContactInfo: false,
      isFullScreenContact: false,
      studentSocket: null,
      privateSocket: null,
      sendingFileUrl: "",
      defaultimg: true,
      data_loding: true,
    };
  },

  async created() {
    // await this.getstudentdetails();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    this.connectWebSocket();
    document.addEventListener("click", this.handleClickOutside);
    setTimeout(() => {
      let chatContainer = document.getElementById("chatContainer");

      if (chatContainer) {
        console.log("Height::::=", chatContainer.offsetHeight);
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }
    }, 200);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this.privateSocket) {
      this.privateSocket.close();
    }
    if (this.studentSocket) {
      this.studentSocket.close();
    }
  },

  methods: {
    connectWebSocket() {
      if (this.studentSocket) this.studentSocket.close();

      const socket = new WebSocket(
        `${process.env.VUE_APP_SOCKET_URL}/ws/messages/${this.course_id}/?Key=${this.userInfo.token_key}`
      );

      socket.onopen = () => {
        console.log("WebSocket connected (student list)");
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.studentList = data.data;
        console.log("event.data staff", event.data);
        // if (this.studentList.length > 0) {
        //   this.setActiveStudent(this.studentList[0]);
        // }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      };

      socket.onerror = (error) => {
        console.error("Student list WebSocket error:", error);
      };

      socket.onclose = () => {
        console.warn("Student list WebSocket closed.");
      };

      this.studentSocket = socket;
    },
    toggleDropdown(index) {
      this.dropdownIndex = this.dropdownIndex === index ? null : index;
    },
    downloadFile(message) {
      const link = document.createElement("a");
      link.href = message.file;
      link.download = message.filename || this.getFileName(message.file);
      link.target = "_blank"; // Open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.dropdownIndex = null;
    },
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    triggerInput(type) {
      this.$refs[type].click();
    },
    handleFile(type, event) {
      const file = event.target.files[0];
      if (!file) return;

      this.fileData.name = file.name;
      this.fileData.type = type;
      this.fileData.raw = file;

      if (type === "image" || type === "video") {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileData.url = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.fileData.url = "";
      }

      this.toggleIcons();
    },
    clearPreview() {
      this.fileData = { type: "", name: "", url: "", raw: null };
      ["document", "image", "video"].forEach((type) => {
        if (this.$refs[type]) this.$refs[type].value = "";
      });
    },
    toggleIcons() {
      this.showIcons = !this.showIcons;
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.showIcons = false;
      }
    },
    formatDateTime(isoString) {
      const date = new Date(isoString);

      const daysOfWeek = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
      const dayName = daysOfWeek[date.getDay()];

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12;

      return `${dayName} ${hours}:${minutes} ${ampm}`;
      // Output: Sunday 09/04/2025 5:20 PM
    },

    formatDateLabel(isoString) {
      const date = new Date(isoString);
      const now = new Date();

      const isToday = date.toDateString() === now.toDateString();

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);
      const isYesterday = date.toDateString() === yesterday.toDateString();

      if (isToday) return "Today";
      if (isYesterday) return "Yesterday";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    shouldShowDateLabel(index) {
      if (index === 0) return true;

      const current = this.formatDateLabel(this.totalmessage[index].created_at);
      const previous = this.formatDateLabel(
        this.totalmessage[index - 1].created_at
      );

      return current !== previous;
    },

    scrollToBottomChat() {
      setTimeout(() => {
        let chatContainer = document.getElementById("chatContainer");
        if (chatContainer) {
          console.log("Height::::=", chatContainer.offsetHeight);

          chatContainer.scrollTo({
            top: chatContainer.scrollHeight + 300,
            behavior: "smooth",
          });
        }
      }, 200);
    },

    // async getstudentdetails() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/message-room-get/?Key=${this.userInfo.token_key}&course__id=${this.course_id}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.studentList = response.data.data || [];

    //         if (this.studentList.length > 0) {
    //           const firstGroup = this.studentList[0];
    //           this.activeGroup = firstGroup.title || "Untitled";
    //           this.messageInfo(firstGroup);
    //         }
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 500);
    //       } else if (response.data.status == 400) {
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 500);

    //         this.studentList = [];
    //       }
    //     });
    // },

    // async getstudentdetailsforwebsocket() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/message-room-get/?Key=${this.userInfo.token_key}&course__id=${this.course_id}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.studentList = response.data.data || [];
    //       } else if (response.data.status == 400) {
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 500);
    //         this.studentList = [];
    //       }
    //     });
    // },

    async setActiveStudent(student) {
      this.data_loding = true;
      this.defaultimg = false;
      this.activeStudentUUID = student.uuid;
      localStorage.setItem("activeStudentUUID", student.uuid);
      this.selectedStudent = student;
      this.studentmessage = false;
      this.totalmessage = [];
      this.websocket(student);
      await this.getmessage(student);
    },

    // async getmessage(data) {
    //   this.selectedStudent = data;
    //   console.log(" this.selectedStudent", this.selectedStudent);

    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/message-chat-retrieve/${this.selectedStudent.uuid}/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((Response) => {
    //       if (Response.data.status == 200) {
    //         this.totalmessage = Response.data.data;
    //         this.message_list = this.totalmessage.map((msg) => msg.id);
    //         // console.log("this.totalmessage123", this.message_list);
    //         console.log("array:::", Response.data.id_list);
    //         //  this.updateMessage();
    //         // this.websocket(data);
    //         if (this.socket && this.socket.readyState === WebSocket.OPEN) {
    //           const message = {
    //             type: "mark_as_read",
    //             message_ids: Response.data.id_list,
    //           };
    //           this.socket.send(JSON.stringify(message));
    //         }
    //       }
    //     });
    //   this.scrollToBottomChat();
    // },
    async getmessage(student) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/message-chat-retrieve/${student.uuid}/?Key=${this.userInfo.token_key}`
        );

        if (response.data.status === 200) {
          this.totalmessage = response.data.data || [];

          if (
            this.privateSocket &&
            this.privateSocket.readyState === WebSocket.OPEN
          ) {
            const message = {
              type: "mark_as_read",
              message_ids: response.data.id_list,
            };

            this.privateSocket.send(JSON.stringify(message));
          }
          setTimeout(() => {
            this.data_loding = false;
            this.scrollToBottomChat();
          }, 600);
        } else {
          console.error("Unexpected response:", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch messages", error);
      }
    },
    websocket(student) {
      if (this.privateSocket) this.privateSocket.close();

      const socket = new WebSocket(
        `${process.env.VUE_APP_SOCKET_URL}/ws/private-chat/${student.uuid}/?Key=${this.userInfo.token_key}`
      );
      this.privateSocket = socket;

      socket.onopen = () => {
        console.log(`Connected to private chat ${student.uuid}`);
      };

      socket.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          if (msg.file) {
            this.sendingFileUrl = "";
          }
          if (msg.file?.startsWith("/media/")) {
            msg.file = `${process.env.VUE_APP_API}${msg.file}`;
          }

          const ownerId = this.userInfo.user.id;
          const clientId = this.selectedStudent?.to_user?.id;
          console.log("event.data instructor", event.data);

          if (
            (msg.owner_id === ownerId && msg.client_id === clientId) ||
            (msg.client_id === ownerId && msg.owner_id === clientId)
          ) {
            this.totalmessage.push(msg);
            this.scrollToBottomChat();

            // this.getmessage(student)
          }
        } catch (err) {
          console.error("Error parsing incoming message:", err);
        }
      };

      socket.onclose = () => {
        console.log("Private chat WebSocket closed.");
      };

      socket.onerror = (error) => {
        console.error("Private chat WebSocket error:", error);
      };
    },
    sendmsg() {
      const text = this.messageVal?.trim();

      if (!text && !this.fileData?.name) {
        console.warn("Empty message and no file selected.");
        return;
      }

      const message = {
        username: this.userInfo.user.email,
        text: text || "",
      };

      if (this.fileData.name) {
        message.filename = this.fileData.name;

        if (this.fileData.url) {
          message.filedata = this.fileData.url;
          this.sendingFileUrl = this.fileData.url;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            message.filedata = e.target.result;
            this.sendingFileUrl = e.target.result;
            this.sendWebSocketMessage(message);
          };
          reader.readAsDataURL(this.fileData.raw);
          return;
        }
      }

      this.sendWebSocketMessage(message);
    },

    sendWebSocketMessage(message) {
      if (
        this.privateSocket &&
        this.privateSocket.readyState === WebSocket.OPEN
      ) {
        this.privateSocket.send(JSON.stringify(message));
        this.scrollToBottomChat();
        this.messageVal = "";
        this.clearPreview();
      } else {
        console.warn("WebSocket is not connected.");
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
